import React from 'react';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import CancelIcon from '@mui/icons-material/Cancel';
import Divider from '@mui/material/Divider';

export default function MainInput({
  price,
  onSeach,
  onChange,
  onRemove,
  numberInput,
}) {
  return (
    <Paper
      component="form"
      sx={{ p: '2px 4px', width: '100%', display: 'flex' }}
      onSubmit={onSeach}
    >
      <InputBase
        type="number"
        sx={{ ml: 1, flexGrow: 1 }}
        value={price}
        onChange={onChange}
        ref={numberInput}
      />
      <IconButton
        type="button"
        sx={{ p: '10px', opacity: price ? 1 : 0 }}
        style={{ transitionDuration: '0.1s' }}
        aria-label="remove"
        onClick={onRemove}
      >
        <CancelIcon />
      </IconButton>
      <Divider sx={{ height: 34, m: 0.5 }} orientation="vertical" />
      <IconButton type="submit" sx={{ p: '10px' }} aria-label="search">
        <SearchIcon />
      </IconButton>
    </Paper>
  );
}
